import React from "react";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails } from "../assets/serviciosDetalle";
import ServiceCta from "../components/ServiceCta";
import ServiceHero from "../components/ServiceHero";
import ServiceSection from "../components/ServiceSection";
import ServiceSectionHead from "../components/ServiceSectionHead";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["servicios-medicos"];
const medicalNavTheme = {
    ...serviciosNavTheme,
    primary: "#dc2626",
    primaryDark: "#991b1b",
    primaryLight: "#fecaca",
    pale: "rgba(220, 38, 38, 0.08)",
};
const [, servicesSection, processSection, sectorsSection] = service.sections;

export default function ServiciosMedicos() {
    return (
        <div className="servicios servicio-detalle service-page-servicios-medicos">
            <SiteNavbar activeSection="servicios" ctaLabel="Contactar" ctaHref="#contacto" navTheme={medicalNavTheme} />
            <ServiceHero service={service} />
            <ServiceSection section={{ ...servicesSection, variant: "medical-services" }} />
            <ServiceSection section={processSection} />

            <section className="service-detail-section service-section-medical-sectors">
                <div className="service-detail-inner">
                    <ServiceSectionHead
                        section={{
                            ...sectorsSection,
                            text: "Trabajamos con empresas e instituciones, eventos deportivos y corporativos, maratones, estadios, clubes, shoppings, centros comerciales, escuelas, universidades, gimnasios, espacios de wellness, organismos públicos y predios privados que necesitan cobertura médica profesional y capacidad de respuesta inmediata.",
                        }}
                    />
                </div>
            </section>

            <ServiceCta service={service} />
            <SiteFooter/>
        </div>
    );
}
